<template>
  <div class="co-re-wrap">
    <img src="../assets/mask/cooperation.png" alt="配图" class="left-img" />
    <div class="co-re-form">
      <div class="form-line">
        <h3 class="form-title">合作意向登记</h3>
      </div>
      <div class="form-line">
        <div class="input-wrap">
          <input
            type="text"
            class="form-input"
            v-model="formData.companyName"
            placeholder="请输入公司名称"
            @change="validateCompanyName(formData.companyName)"
          />
          <div
            class="error-tip"
            v-if="validateData.companyNameError"
          >{{validateData.companyNameErrorTip}}</div>
        </div>
      </div>
      <div class="form-line">
        <div class="input-wrap">
          <input
            type="text"
            class="form-input"
            v-model="formData.linkman"
            placeholder="请输入联系人"
            @change="validateLinkman(formData.linkman)"
          />
          <div class="error-tip" v-if="validateData.linkmanError">{{validateData.linkmanErrorTip}}</div>
        </div>
      </div>
      <div class="form-line">
        <div class="input-wrap">
          <input
            type="tel"
            class="form-input"
            v-model="formData.tel"
            placeholder="请输入电话号码"
            @keyup="onlyNumber('tel', 20)"
            @change="validateTel(formData.tel)"
          />
          <div class="error-tip" v-if="validateData.telError">{{validateData.telErrorTip}}</div>
        </div>
      </div>
      <div class="form-line">
        <div class="input-wrap">
          <input
            type="tel"
            class="form-input"
            v-model="formData.qq"
            placeholder="请输入QQ号码"
            @keyup="onlyNumber('qq', 12)"
            @change="validateQq(formData.qq)"
          />
          <div class="error-tip" v-if="validateData.qqError">{{validateData.qqErrorTip}}</div>
        </div>
      </div>
      <div class="form-line">
        <div class="input-wrap">
          <input
            type="text"
            class="form-input"
            v-model="formData.duty"
            placeholder="请输入您的职务"
            @change="validateDuty(formData.duty)"
          />
          <div class="error-tip" v-if="validateData.dutyError">{{validateData.dutyErrorTip}}</div>
        </div>
      </div>
      <div class="form-line">
        <div class="input-wrap area-input-wrap">
          <div class="area-title">区域</div>
          <div class="area-contnet">
            <el-cascader
              class="area-select"
              v-model="formData.district"
              :options="aeraList"
              @change="validateDistrict(formData.district)"
              :clearable="true"
              :filterable="true"
            ></el-cascader>
            <input
              type="text"
              v-model="formData.address"
              class="form-input area-detail"
              placeholder="请输入详细地址"
              @change="validateAddress(formData.address)"
            />
          </div>
          <div
            class="error-tip"
            v-if="validateData.districtError || validateData.addressError"
          >{{validateData.districtErrorTip}}</div>
        </div>
      </div>
      <div class="form-line">
        <div class="input-wrap">
          <el-select
            v-model="formData.cooperationAreas"
            placeholder="请选择意向合作领域"
            class="input-select"
            @change="validateCooperationAreas(formData.cooperationAreas)"
          >
            <el-option
              v-for="item in cooperationList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <div
            class="error-tip"
            v-if="validateData.cooperationAreasError"
          >{{validateData.cooperationAreasErrorTip}}</div>
        </div>
      </div>
      <div class="form-line">
        <div class="input-wrap textarea-wrap">
          <textarea
            type="text"
            class="form-input form-textarea"
            v-model="formData.advantage"
            placeholder="请描述一下您的优势"
            @change="validateAdvantage(formData.advantage)"
          ></textarea>
          <div
            class="error-tip"
            v-if="validateData.advantageError"
          >{{validateData.advantageErrorTip}}</div>
        </div>
      </div>
      <div class="form-line">
        <div class="input-wrap">
          <input
            type="text"
            class="form-input form-Authcode"
            v-model="formData.verificationCode"
            placeholder="请输入验证码"
            @change="validateVerificationCode(formData.verificationCode)"
            @keyup="onlyNumber('verificationCode', 6)"
          />
          <div class="authcode-wrap" @click="_getAuthCode">
            <img :src="authcodeUrl" alt="验证码" />
          </div>
          <div
            class="error-tip"
            v-if="validateData.verificationCodeError"
          >{{validateData.verificationCodeErrorTip}}</div>
        </div>
      </div>
      <div class="form-line">
        <div class="input-wrap co-btns-wrap">
          <div class="co-save" @click="submitApply">确定</div>
          <div class="co-close" @click="$emit('close')">关闭</div>
        </div>
      </div>
    </div>
    <div class="co-re-close" @click="$emit('close')"></div>
    <div class="success-wrap" v-if="isSubmitSuccess">
      <div class="success-popup">
        <img src="../assets/mask/success.png" alt="成功" class="success-img" />
        <p class="success-p1">您的合作意向已登记</p>
        <p class="success-p2">我们的商务人员会尽快联系您,谢谢！</p>
        <div class="success-btn" @click="$emit('close')">关闭</div>
      </div>
    </div>
  </div>
</template>

<script >
import areaMap from "@/util/areaMap";
import { getVerificationCode, registerCooperation } from "@/api";
import { Cascader, Select, Option } from "element-ui";
export default {
  name: "cooperationRegister",
  components: {
    "el-cascader": Cascader,
    "el-select": Select,
    "el-option": Option
  },
  data() {
    return {
      formData: {
        companyName: "",
        linkman: "",
        tel: "",
        qq: "",
        duty: "",
        district: "",
        address: "",
        cooperationAreas: "",
        advantage: "",
        verificationCode: ""
      },
      validateData: {
        companyNameError: false,
        linkmanError: false,
        telError: false,
        qqError: false,
        dutyError: false,
        districtError: false,
        addressError: false,
        cooperationAreasError: false,
        advantageError: false,
        verificationCodeError: false,
        companyNameErrorTip: "不能为空",
        linkmanErrorTip: "不能为空",
        telErrorTip: "不能为空",
        qqErrorTip: "不能为空",
        dutyErrorTip: "不能为空",
        districtErrorTip: "不能为空",
        addressErrorTip: "不能为空",
        cooperationAreasErrorTip: "不能为空",
        advantageErrorTip: "不能为空",
        verificationCodeErrorTip: "不能为空"
      },
      areaValue: "",
      aeraList: areaMap,
      cooperationList: [
        { value: "媒体类", lable: "媒体类" },
        { value: "服务商类", lable: "服务商类" },
        { value: "协会类", lable: "协会类" },
        { value: "学院类", lable: "学院类" },
        { value: "平台类", lable: "平台类" },
        { value: "仓储物流类", lable: "仓储物流类" },
        { value: "其他", lable: "其他" }
      ],
      identification: "",
      authcodeUrl: "",
      submitting: false,
      isSubmitSuccess: false
    };
  },
  methods: {
    submitApply() {
      // 提交表单
      if (this.submitting) return; // 防止连续点击
      let keys = Object.keys(this.formData),
        flag = true;
      keys.forEach(key => {
        // 表单验证
        let methodName = "validate" + key.replace(key[0], key[0].toUpperCase());
        this[methodName](this.formData[key]);
        if (this.validateData[key + "Error"]) {
          flag = false;
        }
      });
      if (!flag) return;
      let params = Object.assign({}, this.formData);
      params.district = params.district.join("/"); // 省市区地址拼接
      params.identification = this.identification; // 加上身份标识
      this.submitting = true;
      registerCooperation(params)
        .then(res => {
          // 调用接口
          if (res.subCode === "0201121109") {
            // 验证码错误
            this.validateData.verificationCodeError = true;
            this.validateData.verificationCodeErrorTip = "验证码错误";
          } else if (res.subCode === "0201101110") {
            // 提交成功
            this.isSubmitSuccess = true;
          }
          this._getAuthCode();
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    validateCompanyName(val) {
      if (!val) {
        this.validateData.companyNameError = true;
        this.validateData.companyNameErrorTip = "请输入公司名称！";
        return;
      }
      if (val.length > 30) {
        this.validateData.companyNameError = true;
        this.validateData.companyNameErrorTip = "长度不能超过30！";
        return;
      }
      if (!/^[a-zA-Z\u4e00-\u9fa5（）()]+$/.test(val)) {
        this.validateData.companyNameError = true;
        this.validateData.companyNameErrorTip = "只能输入中英文！";
        return;
      }
      this.validateData.companyNameError = false;
    },
    validateLinkman(val) {
      if (!val) {
        this.validateData.linkmanError = true;
        this.validateData.linkmanErrorTip = "请输入联系人！";
        return;
      }
      if (val.length > 20) {
        this.validateData.linkmanError = true;
        this.validateData.linkmanErrorTip = "长度不能超过20！";
        return;
      }
      if (!/^[a-zA-Z\u4e00-\u9fa5]+$/.test(val)) {
        this.validateData.linkmanError = true;
        this.validateData.linkmanErrorTip = "只能输入中英文！";
        return;
      }
      this.validateData.linkmanError = false;
    },
    validateTel(val) {
      if (!val) {
        this.validateData.telError = true;
        this.validateData.telErrorTip = "电话不能为空！";
        return;
      }
      let phoneReg = /^(1[3-9]{1})\d{9}$/,
        telReg = /^(0\d{2,3}-?\s?)?\d{7,8}$/;
      if (!phoneReg.test(val) && !telReg.test(val)) {
        this.validateData.telError = true;
        this.validateData.telErrorTip = "格式错误！";
        return;
      }
      this.validateData.telError = false;
    },
    validateQq(val) {
      if (!val) {
        this.validateData.qqError = true;
        this.validateData.qqErrorTip = "请输入QQ号！";
        return;
      }
      if (!/^[1-9][0-9]{3,11}$/.test(val)) {
        this.validateData.qqError = true;
        this.validateData.qqErrorTip = "格式错误";
        return;
      }
      this.validateData.qqError = false;
    },
    validateDuty(val) {
      if (!val) {
        this.validateData.dutyError = true;
        this.validateData.dutyErrorTip = "请输入职务！";
        return;
      }
      if (!/^[a-zA-Z\u4e00-\u9fa5]+$/.test(val)) {
        this.validateData.dutyError = true;
        this.validateData.dutyErrorTip = "只能输入中英文";
        return;
      }
      if (val.length > 20) {
        this.validateData.dutyError = true;
        this.validateData.dutyErrorTip = "长度不能超过20！";
        return;
      }
      this.validateData.dutyError = false;
    },
    validateDistrict(val) {
      if (!val) {
        this.validateData.districtError = true;
        this.validateData.districtErrorTip = "区域不能为空！";
        return;
      }
      this.validateData.districtError = false;
    },
    validateAddress(val) {
      if (!val) {
        this.validateData.addressError = true;
        this.validateData.districtErrorTip = "请输入详细地址";
        return;
      }
      if (val.length > 100) {
        this.validateData.addressError = true;
        this.validateData.districtErrorTip = "详细地址过长";
        return;
      }
      this.validateData.addressError = false;
    },
    validateCooperationAreas(val) {
      if (!val) {
        this.validateData.cooperationAreasError = true;
        this.validateData.cooperationAreasErrorTip = "请选择合作领域！";
        return;
      }
      this.validateData.cooperationAreasError = false;
    },
    validateAdvantage(val) {
      if (!val) {
        this.validateData.advantageError = true;
        this.validateData.advantageErrorTip = "请输入您的优势！";
        return;
      }
      if (val.length > 1000) {
        this.validateData.advantageError = true;
        this.validateData.advantageErrorTip = "内容超过1千字符";
        return;
      }
      this.validateData.advantageError = false;
    },
    validateVerificationCode(val) {
      if (!val) {
        this.validateData.verificationCodeError = true;
        this.validateData.verificationCodeErrorTip = "请输入验证码！";
        return;
      }
      this.validateData.verificationCodeError = false;
    },
    onlyNumber(key, len) {
      let val = this.formData[key];
      if (val.length > len) {
        this.formData[key] = val.substring(0, len);
      }
      if (/[^\d]/g.test(val)) {
        this.formData[key] = val.replace(/[^\d]/g, "");
      }
    },
    _getAuthCode() {
      this.authcodeUrl =
        "/cms-pdrs/open/website/getVerificationCode?identification=" +
        this.identification +
        "&timestamp=" +
        new Date().getTime();
    }
  },
  created() {
    this.identification =
      "" + new Date().getTime() + Math.floor(Math.random() * 1000);
    this.authcodeUrl =
      "/cms-pdrs/open/website/getVerificationCode?identification=" +
      this.identification;
  }
};
</script>

<style lang="less" scope>
@deep: ~'>>>';
.co-re-wrap {
  position: relative;
  margin: auto;
  width: 1000px;
  height: 720px;
  background-color: rgba(251, 251, 251);
  font-family: Source Han Sans CN;
  text-align: left;
}
.left-img {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 386px;
  height: 720px;
}
.co-re-form {
  position: absolute;
  top: 0;
  right: 0;
  width: 572px;
  height: 720px;
}
.form-line {
  padding-left: 70px;
}
.form-title {
  height: 30px;
  margin: 28px auto 22px 0;
  font-size: 24px;
  font-weight: 500;
  line-height: 30px;
  color: rgba(51, 51, 51, 1);
}
.input-wrap {
  position: relative;
  height: 36px;
  margin-bottom: 10px;
}
.form-input {
  box-sizing: border-box;
  width: 374px;
  height: 36px;
  padding-left: 15px;
  border: 1px solid #ececec;
  border-radius: 4px;
  outline: none;
  color: #666;
}
.form-input:focus {
  border-color: #409eff;
  z-index: 1;
}
.el-scrollbar__wrap {
  height: 300px !important;
}
.area-input-wrap,
.textarea-wrap {
  height: auto !important;
}
.area-title {
  display: inline-block;
  vertical-align: top;
  box-sizing: border-box;
  width: 65px;
  height: 70px;
  border: 1px solid #ececec;
  border-radius: 4px 0 0 4px;
  background-color: #ffffff;
  line-height: 72px;
  text-align: center;
  color: #c0c4cc;
  font-size: 14px;
}
.area-contnet {
  position: relative;
  left: -5px;
  display: inline-block;
  vertical-align: top;
  width: 310px;
  height: 70px;
}
.area-select {
  width: 310px;
  height: 36px;
  margin: 0;
}
.area-select @{deep} .el-input {
  min-height: 0;
  height: 36px;
}
.area-select @{deep} .el-input__inner {
  position: absolute;
  top: 0;
  left: 0;
  height: 36px;
  min-height: 0;
  border: 1px solid #ececec;
  border-radius: 0 4px 0 0;
  outline: none;
  color: #666;
}
.area-select @{deep} .el-input__inner:focus,
.area-select @{deep} .el-input__inner:hover,
.area-select @{deep} .el-input.is-focus .el-input__inner {
  z-index: 1;
}
.area-detail {
  position: relative;
  top: -5px;
  width: 310px !important;
  border-radius: 0 0 4px 0;
}
.form-textarea {
  width: 374px;
  height: 120px;
  padding-top: 10px;
  resize: none;
}
.input-select {
  width: 374px;
}
.form-Authcode {
  vertical-align: top;
  width: 268px;
}
.authcode-wrap {
  display: inline-block;
  vertical-align: top;
  box-sizing: border-box;
  width: 96px;
  height: 36px;
  margin-left: 6px;
  border: 1px solid #ececec;
  background-color: #fff;
  cursor: pointer;
}
.co-btns-wrap {
  display: flex;
  justify-content: space-around;
  width: 374px;
  margin-top: 38px;
}
.co-save,
.co-close {
  display: inline-block;
  width: 160px;
  height: 36px;
  background-color: #5485e8;
  font-size: 18px;
  text-align: center;
  line-height: 36px;
  color: #fff;
  cursor: pointer;
}
.co-close {
  background-color: #fff;
  border: 1px solid #ececec;
  color: #999999;
}
.error-tip {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 384px;
  color: #eb5555;
}
// .co-re-close {
//   position: absolute;
//   right: 24px;
//   top: 24px;
//   width: 28px;
//   height: 28px;
//   background-image: url("../assets/platform/close.png");
//   background-repeat: no-repeat;
//   background-size: 28px 28px;
//   cursor: pointer;
// }

  .co-re-close {
    position: absolute;
    right: 14px;
    top: 11px;
    width: 30px;
    height: 24px;
  }

  .co-re-close::before,
  .co-re-close::after {
    position: absolute;
    content: " ";
    background-color: #999;
    left: 20px;
    width: 2px;
    height: 25px;
  }

  .co-re-close::before {
    transform: rotate(45deg);
  }

  .co-re-close::after {
    transform: rotate(-45deg);
  }

  .co-re-close:hover:before,
  .co-re-close:hover:after{
    background-color: #5485E8;
  }
.success-wrap {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.success-popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 440px;
  height: 240px;
  background-color: #fff;
  text-align: center;
  box-shadow: 1px 1px 6px #999;
}
.success-img {
  width: 48px;
  height: 48px;
  margin: 30px auto 20px auto;
}
.success-p1 {
  margin-bottom: 6px;
  font-size: 20px;
  color: #333333;
}
.success-p2 {
  margin-bottom: 20px;
  font-size: 16px;
  color: #999999;
}
.success-btn {
  width: 180px;
  height: 36px;
  margin: auto;
  border: 1px solid #e1dede;
  line-height: 36px;
  color: #999;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/cooperation-register.vue